export default "__VITE_ASSET__5f3c5527__"